import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBreakpoint } from '@airtel/air-design-system';
import { useEffect } from 'react';
import { View } from 'react-native';
import { ButtonWidgetComponent } from '../../../button-widget/ButtonWidget';
import { ScrollLinkListWidget } from '../../../scroll-link-list-widget';
import { getTrackOrderCardStyles } from './TrackOrderCardStyles';
import { addNoVerticalPadding, isSingleBtn, trackOrderGridLayoutProps } from './TrackOrderCardUtils';
export var TrackOrderCardComponent = props => {
  var id = props.id,
    index = props.index,
    isLastItem = props.isLastItem,
    list = props.list,
    onUserAction = props.onUserAction,
    listStyle = props.listStyle,
    scrollLinkStyle = props.scrollLinkStyle;
  var _props$item = props.item,
    _props$item$linkedLis = _props$item.linkedListData,
    linkedListData = _props$item$linkedLis === void 0 ? [] : _props$item$linkedLis,
    bottomCta = _props$item.bottomCta,
    onItemImpressionMetaData = _props$item.onItemImpressionMetaData;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var isMultiple = (list === null || list === void 0 ? void 0 : list.length) > 1 && isLargeScreen;
  var linkedList = addNoVerticalPadding([...linkedListData]);
  var trackOrderCardStyles = getTrackOrderCardStyles(isLastItem);
  var isSingleCta = isSingleBtn(bottomCta);
  var showGridInCta = isMultiple || isSingleCta && isLargeScreen;
  var trackOrderGridProps = showGridInCta && trackOrderGridLayoutProps();
  useEffect(() => {
    onItemImpressionMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onItemImpressionMetaData), Object.assign(Object.assign({}, props.item), {
      index
    })));
  }, []);
  return _jsxs(View, Object.assign({
    style: [trackOrderCardStyles.listContent, listStyle]
  }, {
    children: [_jsx(ScrollLinkListWidget, {
      showDivider: false,
      data: linkedList,
      style: scrollLinkStyle,
      onUserAction: onUserAction
    }), !!bottomCta && _jsx(ButtonWidgetComponent, Object.assign({}, trackOrderGridProps, bottomCta, {
      onUserAction: onUserAction,
      style: trackOrderCardStyles.buttonContainer
    }))]
  }), "cardview_" + index);
};